// `highFrequency: true` marks a *restricted* event — one a domain emits at a rate
// that makes it a poor fit for anything that acts on every occurrence (campaign
// triggers, pipeline forwarding). Everything unflagged is unrestricted and can be
// offered whether or not the domain has emitted it yet.
//
// This mirrors HIGH_FREQUENCY_EVENTS in magellan-api's helpers/trigger-event-helper.js
// (which the trigger allowlist endpoint applies server-side), plus pageEngagement and
// campaignSplitEnter — both fire alongside an event that list already restricts — and
// autocompleteInteraction, which fires once per keystroke.
// Keep the two in sync when either gains an event.
const eventTypes = [
  { label: 'Email Rescheduled', value: 'emailReschedule' },
  { label: 'Email Sent', value: 'emailSend', highFrequency: true },
  { label: 'Email Delivered', value: 'emailDelivery', highFrequency: true },
  { label: 'Email Opened', value: 'emailOpen' },
  { label: 'Email Clicked', value: 'emailClick' },
  { label: 'Entered Campaign', value: 'campaignEnter', highFrequency: true },
  { label: 'Entered Campaign Branch', value: 'campaignSplitEnter', highFrequency: true },
  { label: 'Email Bounced', value: 'emailBounce' },
  { label: 'Email Complaint', value: 'emailComplaint' },
  { label: 'Email Skipped', value: 'emailSkip' },
  { label: 'Viewed Page', value: 'pageView', highFrequency: true },
  { label: 'Page Engagement', value: 'pageEngagement', highFrequency: true },
  { label: 'Viewed Product', value: 'productView', highFrequency: true },
  { label: 'Banner Clicked', value: 'bannerClick' },
  { label: 'Recommender Clicked', value: 'recommenderClick' },
  { label: 'Push Notification Subscribe', value: 'pushNotificationSubscribe' },
  { label: 'Push Notification Sent', value: 'pushNotificationSend', highFrequency: true },
  { label: 'PushNotification Click', value: 'pushNotificationClick' },
  { label: 'PushNotification Bounce', value: 'pushNotificationBounce' },
  { label: 'Push Notification Delivered', value: 'pushNotificationDelivery', highFrequency: true },
  { label: 'Text Message Sent', value: 'textMessageSend', highFrequency: true },
  { label: 'Text Message Clicked', value: 'textMessageClick' },
  { label: 'Viber Message Sent', value: 'viberMessageSend', highFrequency: true },
  { label: 'Viber Message Clicked', value: 'viberMessageClick' },
  { label: 'Viber Message Delivered', value: 'viberMessageDelivery', highFrequency: true },
  { label: 'Viber Message Bounces', value: 'viberMessageBounce' },
  { label: 'Viber Message Opened', value: 'viberMessageOpen' },
  { label: 'Viber Message Expired', value: 'viberMessageExpired' },
  { label: 'Cart Checkout Completed', value: 'cartCheckoutSuccess' },
  { label: 'Checkout Initiated', value: 'checkoutInitiate' },
  { label: 'Payment Info Added', value: 'addPaymentInfo' },
  { label: 'Cart Item Added', value: 'cartAdd' },
  { label: 'Cart Item Removed', value: 'cartRemove' },
  { label: 'Cart Updated', value: 'cartUpdate' },
  { label: 'Cart Created', value: 'cartCreate' },
  { label: 'Item Added to Wishlist', value: 'wishlistAdd' },
  { label: 'Item Removed from Wishlist', value: 'wishlistRemove' },
  { label: 'Wishlist Created', value: 'wishlistCreate' },
  { label: 'Subscribed', value: 'subscribe' },
  { label: 'Subscribe Request Submitted', value: 'subscribeRequest' },
  { label: 'Unsubscribed', value: 'unsubscribe' },
  { label: 'Search', value: 'search', highFrequency: true },
  { label: 'Search as you type', value: 'autocompleteInteraction', highFrequency: true },
  { label: 'Registered', value: 'register' },
  { label: 'UTM Session Started', value: 'utmSessionStart', highFrequency: true },
  { label: 'WhatsApp Message Sent', value: 'whatsappMessageSend', highFrequency: true },
  { label: 'WhatsApp Message Clicked', value: 'whatsappMessageClick' },
  { label: 'WhatsApp Message Delivered', value: 'whatsappMessageDelivery', highFrequency: true },
  { label: 'WhatsApp Message Bounces', value: 'whatsappMessageBounce' },
  { label: 'WhatsApp Message Opened', value: 'whatsappMessageOpen' },
  { label: 'WhatsApp Message Deleted', value: 'whatsappMessageDeleted' },
  { label: 'Webhook Opened', value: 'webhookOpen' },
  { label: 'Webhook Clicked', value: 'webhookClick' },
  { label: 'Webhook Bounced', value: 'webhookBounce' },
  { label: 'Webhook Sent', value: 'webhookSend', highFrequency: true },
  { label: 'Webhook Delivered', value: 'webhookDelivered', highFrequency: true },
  { label: 'Survey Opened', value: 'surveyOpen' },
  { label: 'Survey Completed', value: 'surveySubmission' },
  { label: 'Loyalty Points Earned', value: 'loyaltyGrant' },
  { label: 'Loyalty Coupon Purchased', value: 'loyaltyCouponPurchase' },
  { label: 'Order Status Changed', value: 'orderStatusChanged' },
  { label: 'Refund', value: 'refund' },
  { label: 'Profile Merged', value: 'merge' },
  { label: 'Clicked a product the sales agent recommended', value: 'salesAgentProductClick' },
];

export default eventTypes;
